const escapeHtml = (text: any): string | number => {
    if (typeof text === 'number') {
        return text
    }

    if (typeof text !== 'string') {
        return ''
    }

    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
    }

    return text.replace(/[&<>"']/g, (match: string) => map[match])
}

export default escapeHtml
